export const CAMPAIGNS_KEY = 'campaigns' as const;
export const STATES_KEY = 'states' as const;
export const CITIES_KEY = 'cities' as const;
export const OWNERSHIP_KEY = 'ownership' as const;
export const LOAN_OFFICERS = 'loan-officers' as const;

export enum MODAL_TYPES {
  SUCCESS = 'SUCCESS',
  INFO = 'INFO',
  WARNING = 'WARNING',
}

export enum POSITION {
  Center = 'center',
  Left = 'left',
  Right = 'right',
  Top = 'top',
  Bottom = 'bottom',
  TopLeft = 'top-left',
  TopRight = 'top-right',
  BottomLeft = 'bottom-left',
  BottomRight = 'bottom-right',
}

export enum SIZE {
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
}

export enum DAYS {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export enum STANDARD_STATUS {
  READY = 'READY',
  PAUSE = 'PAUSE',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  NOT_READY = 'NOT_READY',
}

export enum OWNERSHIP {
  FEESIMPLE = 'FeeSimple',
  INDIVIDUAL = 'Individual',
  CONDOMINIUM = 'Condominium',
  FEE_SIMPLE = 'Fee-Simple',
  PRIVATE = 'Private',
  CONDO = 'Condo',
  OTHER = 'Other',
}

export enum STANDARD_PROPERTY_TYPES {
  HOUSE = 'House',
  LAND = 'Land',
  CONDO = 'Condo',
  COMMERCIAL = 'Commercial',
  TOWNHOUSE = 'Townhouse',
  MULTI_FAMILY = 'Multi-family',
  MANUFACTURED = 'Manufactured',
  APARTMENT = 'Apartment',
  FARM = 'Farm',
}

// Which MLS dataset a campaign queries. Mirrors backend MlsSource. New campaigns default to V2.
// TODO: Andrew mentioned we can remove V1. Double-confirm whether maintaining V1 is too difficult
// before dropping it (would let us delete the source toggle and the V1/V2 dropdown switching).
export enum MLS_SOURCE {
  V1 = 'V1',
  V2 = 'V2',
}

// Native RESO StandardStatus values for V2 campaigns (matched verbatim, no V1 GROUPINGS).
// Mirrors backend NativeStandardStatus. Derived from distinct() on mlsListingsV2 (2026-06-30).
export const V2_STANDARD_STATUSES = [
  'Active',
  'Active Under Contract',
  'Coming Soon',
  'Pending',
  'Closed',
  'Withdrawn',
  'Canceled',
  'Expired',
  'Hold',
  'Off Market',
];

// Native RESO PropertyType values for V2 campaigns. Mirrors backend NativePropertyType.
// Derived from distinct() on mlsListingsV2 (2026-06-30).
export const V2_PROPERTY_TYPES = [
  'Residential',
  'Residential Lease',
  'Residential Income',
  'Land',
  'Commercial Sale',
  'Commercial Lease',
  'Manufactured In Park',
  'Farm',
  'Business Opportunity',
  'Other',
];

export enum CAMPAIGN_TYPES {
  AGENT_IMPORT = 'Agent Import',
  CUSTOM_AUDIENCE = 'Custom Audience'
}

export const TYPE_CUSTOM_AUDIENCE = 'CUSTOM_AUDIENCE'
export const TYPE_AGENT_IMPORT = 'AGENT_IMPORT'

export enum CAMPAIGN_TYPE_ACTIONS {
  CREATE_CUSTOM_AUDIENCE = 'CREATE_CUSTOM_AUDIENCE',
  CREATE_LOFTY_LEADS = 'CREATE_LOFTY_LEADS',
  ONLY_IMPORT_SELLERS_WITH_EMAIL = 'ONLY_IMPORT_SELLERS_WITH_EMAIL'
}